import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './pages/login/login.component';
import { OrderListComponent } from './pages/order-list/order-list.component';
import { pickupGuard } from './guards/pickup.guard';

export enum AppRouting {
  LOGIN = 'login',
  ORDER_LIST = 'order-list',
}

const routes: Routes = [
  {path: AppRouting.LOGIN, component: LoginComponent, canActivate: []},
  {path: AppRouting.ORDER_LIST, component: OrderListComponent, canActivate: [pickupGuard]},
  {path: '**', redirectTo: AppRouting.LOGIN},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
